import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  AppSection,
  OnboardingGuideStatus,
  OnboardingProgressEntry,
  UpdateOnboardingProgressRequest,
  User,
} from '@financial/shared';
import { api } from '../../lib/api';
import { useProfile } from '../profile/useProfile';

export function useSectionOnboarding(section: AppSection, version: string) {
  const profile = useProfile();
  const queryClient = useQueryClient();
  const entry = profile.data?.onboardingProgress?.[section];
  const current = entry?.version === version ? entry : undefined;

  const update = useMutation({
    mutationFn: async (status: OnboardingGuideStatus) => {
      const body: UpdateOnboardingProgressRequest = { section, version, status };
      return (await api.patch<OnboardingProgressEntry>('/users/me/onboarding', body)).data;
    },
    onSuccess: (next) => {
      queryClient.setQueryData<User>(['profile'], (user) => user ? {
        ...user,
        onboardingProgress: { ...user.onboardingProgress, [section]: next },
      } : user);
    },
  });

  return {
    loading: profile.isLoading,
    seen: Boolean(current),
    status: current?.status,
    update,
  };
}
